import { useAppSelector } from '@/redux/hooks'
import { getHeaderTitle } from '../boardItem'
import { InquiryInsertMember } from './inquiryInsertMember'
import { InquiryInsertGuest } from './inquiryInsertGuest'
import { BoardHeader } from '../_components/boardHeader'
import { useResponsive } from '@/hooks/useResponsive'

const InquiryInsertBoard = () => {
  const headerTitle = getHeaderTitle(window.location.pathname)
  const { isAuthenticated } = useAppSelector((state) => state.auth)
  const { isMobile, isTablet, isDesktop } = useResponsive()
  return (
    <>
      {!isMobile && <BoardHeader title={headerTitle} />}
      {isAuthenticated ? <InquiryInsertMember /> : <InquiryInsertGuest />}
    </>
  )
}

export default InquiryInsertBoard
